import { getFromLocalStorage, setInLocalStorage } from '@/helpers/utils';
import { partyTypeEnum } from './enum';

const keyPrefix = 'bankruptcy-lut-';
const subPrefix = 'sub-';

export const isType = (value, type) => value === partyTypeEnum[type];
export const isNotType = (value, type) => value !== partyTypeEnum[type];
export const isOfType = (party, partyType) =>
  party && isType(party.typeId, partyType);
export const isPerson = party => isOfType(party, 'person');
export const isFirm = party => isOfType(party, 'firm');
export const isOrganization = party => isOfType(party, 'organization');
export const getCompanyIdNumber = partyDetails => partyDetails?.unifiedNumber || partyDetails?.commercialRegistrationNumber;
export const getIdTypeName = (identityTypeId, identityTypes = []) => {
  if (!identityTypeId || !identityTypes.length) return '';
  const match = identityTypes.find(t => t.id === identityTypeId);
  return match ? match.name : identityTypeId;
};
export function joinNames(...parts) {
  return parts.filter(Boolean).join(' ');
}
export const getLegalCapacityName = (legalCapacityId, legalCapacities = []) => {
  if (!legalCapacityId || !legalCapacities.length) return '';
  const match = legalCapacities.find(c => c.id === legalCapacityId);
  return match ? match.name : legalCapacityId;
};
export const setLookupInLocalStorage = (key, value) =>
  setInLocalStorage(`${keyPrefix}${key}`, value);

export const setSubLookupInLocalStorage = (relatedId, key, value) => {
  const object = getLookupFromLocalStorage(key, true);
  object[relatedId] = value;
  setInLocalStorage(`${subPrefix}${keyPrefix}${key}`, object);
};

export const updateSubLookupInLocalStorage = (id, storageKey, value) => {
  const object = getLookupFromLocalStorage(storageKey, true);
  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      const index = object[key].findIndex(x => x.id === id);
      object[key][index] = {
        ...object[key][index],
        ...value,
      };
    }
  }
  setInLocalStorage(`${subPrefix}${keyPrefix}${storageKey}`, object);
};

export const getLookupFromLocalStorage = (key, isSubLookup) =>
  getFromLocalStorage(`${isSubLookup ? subPrefix : ''}${keyPrefix}${key}`, isSubLookup ? {} : []);
